// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const jwt = localStorage.getItem('jwt');

  if (!jwt) {
    // Als er geen token is, stuur de gebruiker terug naar de landingspagina.
    // Onthoud de gevraagde pagina (bijvoorbeeld een link naar een doorloopje uit een
    // mail), zodat de landingspagina daar na het inloggen naartoe gaat.
    const from = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to="/" replace state={{ from }} />;
  }

  // Als er wel een token is, toon de gevraagde pagina
  return children;
};

export default ProtectedRoute;
